import { render, staticRenderFns } from "./ShortList.vue?vue&type=template&id=f5e70854"
import script from "./ShortList.vue?vue&type=script&lang=js"
export * from "./ShortList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports